import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountSharedModule } from '@app/account/account-shared.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { LibraryPanesModule } from '@app/library/panes/library-panes.module';
import { NewTeacherCardMiniComponent } from '@app/library/panes/new-teachers/new-teacher-card-mini/new-teacher-card-mini.component';
import { TeacherBookingSurfaceBlockComponent } from '@app/teachers/teacher-card/teacher-booking-surface-block/teacher-booking-surface-block.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { AccountService } from '@core/services';

import { IconComponent } from '@shared/icon/icon.component';
import { User } from 'lingo2-models';
import { OnUiCoverModule } from 'onclass-ui';
import { takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-new-teachers',
  templateUrl: './new-teachers.component.html',
  styleUrls: ['./new-teachers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    LibraryElementsModule,
    RouterModule,
    ScrollingModule,
    LibraryPanesModule,
    ModalModule,
    MobileModalModule,
    OnUiCoverModule,
    AccountSharedModule,
    TeacherBookingSurfaceBlockComponent,
    IconComponent,

    NewTeacherCardMiniComponent,
  ],
})
export class NewTeachersComponent extends AbstractPane implements OnInit {
  @ViewChild('scroller', { read: CdkVirtualScrollViewport })
  scroller: CdkVirtualScrollViewport;

  public isDragScrollEnabled = !(this.deviceService.isMobile() || this.deviceService.isTablet());
  public itemSize = 207;
  public showModal = false;
  public openedCardIndex: number = null;
  public reachedPrev = false;
  public reachedNext = false;
  public item: User;

  private me: User;

  ngOnInit() {
    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        this.me = me;
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }

  public get isTeacher(): boolean {
    return AccountService.isAsIfTeacher(this.me);
  }

  public trackByFn(index, item: User): string {
    return item.id;
  }

  public moveLeft() {
    this.scroller.scrollToIndex(0, 'smooth');
  }

  public moveRight() {
    const offset = this.scroller.measureScrollOffset('left');
    // сдвинуть например на 3 карточки
    this.scroller.scrollToOffset(offset + this.itemSize, 'smooth');
  }

  public onOpenCard(i) {
    this.openedCardIndex = i;
    this.item = this.users[i];
    this.checkReached();
    this.showModal = !!this.item;
  }

  public onCloseCard() {
    this.openedCardIndex = null;
    this.item = null;
    this.showModal = false;
  }

  public onCloseModal(event) {
    if (event) {
      this.onCloseCard();
    }
  }

  public togglePrev(event?) {
    if (this.openedCardIndex - 1 >= 0) {
      this.onOpenCard(this.openedCardIndex - 1);
    }
    this.checkReached();
  }

  public toggleNext(event?) {
    if (this.openedCardIndex + 1 <= this.users.length - 1) {
      this.onOpenCard(this.openedCardIndex + 1);
    }
    this.checkReached();
  }

  public get getSubjectId() {
    return this.item.profile.teaching_subjects[0]?.subject_id;
  }

  public checkReached() {
    const reachedPrev = this.openedCardIndex <= 0;
    const reachedNext = this.openedCardIndex >= this.users.length - 1;

    if (!reachedPrev && !reachedNext) {
      this.reachedPrev = this.reachedNext = false;
    } else if (reachedPrev && reachedNext) {
      this.reachedPrev = this.reachedNext = true;
    } else if (reachedPrev) {
      this.reachedPrev = true;
    } else if (reachedNext) {
      this.reachedNext = true;
    }
  }
}
